import React from 'react';
import PropTypes from 'prop-types';
import StickyFooterLayout from '../common/StickyFooterLayout';
import IntakeTable from './IntakeTable';
import TableInformation from '../SF/table/TableInformation';

function IntakeStudentList(props) {

  const getStickyFooter = () =>
      <TableInformation itemName={props.itemName}
                        itemsPerPage={props.studentsPerPage}
                        start={props.start}
                        totalItems={props.totalStudents}
                        totalSelected={props.selectedStudents.length} />;
  
  return <StickyFooterLayout content={(<IntakeTable {...props} />)} 
                             footer={getStickyFooter()} />
}

IntakeStudentList.defaultProps = {
  itemName: 'Students'
};

IntakeStudentList.propTypes = {
  itemName: PropTypes.string.isRequired,
  selectedStudents: PropTypes.arrayOf(PropTypes.number).isRequired,
  start: PropTypes.number.isRequired,
  studentsPerPage: PropTypes.number.isRequired,
  totalStudents: PropTypes.number.isRequired
};

export default IntakeStudentList;
